export default __webpack_public_path__ + "static/media/music_library.cdb97998.svg";